import documentApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';

type ThisApi = ApiDefinition['/document-request-users/{id}/files/{fileId}/documents']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];

const createUserFileDocument = async ({ id, fileId, metadata }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.post(`/document-request-users/${id}/files/${fileId}/documents`, {
    metadata,
  });
  return response.data;
};

export default createUserFileDocument;
